import { createTheme } from '@mui/material/styles';

// Centralized MUI component overrides.
//
// These replace the auto-generated hashed-class CSS overrides that used to
// live in App.css / index.css (e.g. ".css-1t1j96h-MuiPaper-root-MuiDialog-paper").
// Those hashes are regenerated by Emotion on version bumps, so the old rules
// silently stopped applying whenever MUI was updated. styleOverrides are the
// stable, supported mechanism.
//
// Color values intentionally match the Tailwind design tokens (tailwind.config.js).
const PRIMARY = '#0047FF'; // = Tailwind `primary`

const muiTheme = createTheme({
  components: {
    // All admin modals (was: .css-1t1j96h-MuiPaper-root-MuiDialog-paper)
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    // Sign-in / LDAP tabs (was: .css-1h9z7r5-MuiButtonBase-root-MuiTab-root)
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
          fontSize: 16,
          '&.Mui-selected': {
            color: PRIMARY,
          },
        },
      },
    },
    // (was: .css-1aquho2-MuiTabs-indicator)
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: PRIMARY,
        },
      },
    },
  },
});

export default muiTheme;
